import { transformError } from '../common/recoil/queries';
import { ID, UsersType } from '../common/types';
import { getMembers } from '../recoil/queries';

const getUsersForChatroom = async (usersIds: ID[], practiceId: ID | null) => {
  try {
    const users: UsersType = {};

    const usersPaginatedData = await getMembers(
      { skip: 0, limit: usersIds.length, total: null },
      practiceId,
      [...usersIds],
      null,
    );

    if (!usersPaginatedData.error) {
      for (const user of usersPaginatedData.result.data) {
        users[user._id] = user;
      }
    }

    return {
      error: null,
      result: {
        users,
      },
    };
  } catch (error) {
    return transformError(error);
  }
};

export default getUsersForChatroom;
